import { render } from "./wait-audio.vue?vue&type=template&id=3eb0711f"
import script from "./wait-audio.vue?vue&type=script&lang=js"
export * from "./wait-audio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__